<template>
  <div>
    <p-modal
            size="lg"
            name="addNewSerialModal"
            :label="'Assign Serial Numbers ('+productFamily.description+')'"
            button-label="Add New Serial"
            icon-plus
            @shown="showModal"
            ref="addNewSerialModal"
        >
        <template v-slot:default>
             <p-form ref="form">
            <b-row>
               <b-col>
                    <label>Add New Serial Number</label>
                    <div class="d-flex">
                        <div style="flex: 1 1 0; min-width: 0;">
                            <p-input
                                ref="serialNumber"
                                rules="max:25"
                                placeholder="Scan or type your serial number (ex: HH07222022)"
                                v-model="serialNumber"
                            />
                        </div>
                        <b-button
                            type="button"
                            variant="primary"
                            class="ms-2 flex-shrink-0"
                            style="height: 38px;"
                            :disabled="!serialNumber"
                            @click="addSerialNumber"
                        ><b-icon-plus></b-icon-plus> Add</b-button>
                    </div>
                   
               </b-col>
                    
            </b-row>
             <b-row>
                    <b-col>
                        <p-table
                            :items="serialNumberArr"
                            :fields="fields"
                            :enable-row-selection="false"
                            class="my-3"
                            >
                         <template v-slot:cell(removeDetail)="{ value, item }">
                             <b-button
                                class="p-1 ms-1"
                                @click="deleteSerialNumber(item)"
                            >
                                <BIconTrash
                                    class="my-1 mx-1"
                                ></BIconTrash>
                            </b-button>
                        </template>
                                    
                            </p-table>
                        </b-col>
            </b-row>
             </p-form>
        </template>
         <template v-slot:modal-footer="{cancel }">
            <b-row><b-col>
                    <p-button
                        variant="outline-primary"
                        @click="cancel"
                    >
                        Cancel
                    </p-button>

                    <p-button
                        ref="btnSave"
                        variant="primary"
                        @click="addserialNumber"
                        :disabled="serialNumberArr.length<1"
                        class="ms-2"
                        >Add ({{serialNumberArr.length }}) {{serialNumberArr.length > 1 ? "Serials":"Serial"}}  </p-button
                    >
            </b-col></b-row>
        </template>
        </p-modal>
  </div>
</template>

<script>
export default {
 props: {
        productFamily: Object,
    },
     data() {
        return {
             serialNumber: null,
             serialNumberArr:[],
              fields:[
                {
                    key: 'serialNumber',
                    label: 'Serial Number',
                    sortable: true,
                },
                {
                    key: 'removeDetail',
                    label: 'Delete',
                     thClass: 'text-end',
                    tdClass: 'text-end'
                }
            ],
        }
        },
         methods:{
        addserialNumber(){
             this.serialNumberArr.forEach(s => {
                 if (!this.productFamily.serialNumbers.some(x => x.serialNumber === s.serialNumber)) {
                     this.productFamily.serialNumbers.push(s);
                 }
             });
             this.serialNumberArr = [];
             this.$refs.addNewSerialModal.hide();
        },
        async addSerialNumber(){
             if (!(await this.$refs.form.validate())) {
                return;
            }

            const serial = this.serialNumber ? this.serialNumber.toUpperCase() : '';

            if (this.productFamily.serialNumbers.some(x => x.serialNumber === serial) 
                || this.serialNumberArr.some(x => x.serialNumber === serial)) {
                this.$appError('Cannot duplicate Serial Number')
                return;
            }
            this.serialNumberArr.push({
                serialNumber: serial,
            });
            this.serialNumber = null;
            this.$refs.serialNumber.focus();
        },
        deleteSerialNumber(item) {
            var index = this.serialNumberArr.findIndex(x => x.serialNumber === item.serialNumber);
            this.serialNumberArr.splice(index, 1);
        },
        showModal() {
            this.serialNumber = null;
            this.serialNumberArr = [];
            this.$refs.serialNumber.focus();
        },

    },
}
</script>

<style>

</style>